import { createContext, useContext, useState, ReactNode } from 'react';

interface ChartViewContextType {
  chartDate: string | null;
  setChartDate: (date: string | null) => void;
  fundIdCtx: string | undefined;
  setFundIdCtx: (id: string | undefined) => void;
  hoveredFundId: string | null;
  setHoveredFundId: (id: string | null) => void;
}

const ChartViewContext = createContext<ChartViewContextType | undefined>(
  undefined,
);

export const ChartViewProvider = ({ children }: { children: ReactNode }) => {
  const [chartDate, setChartDate] = useState<string | null>(null);
  const [fundIdCtx, setFundIdCtx] = useState<string>();
  const [hoveredFundId, setHoveredFundId] = useState<string | null>(null);

  return (
    <ChartViewContext.Provider
      value={{
        chartDate,
        setChartDate,
        fundIdCtx,
        setFundIdCtx,
        hoveredFundId,
        setHoveredFundId,
      }}
    >
      {children}
    </ChartViewContext.Provider>
  );
};

export const useChartView = () => {
  const context = useContext(ChartViewContext);
  if (!context) {
    throw new Error('useChartView must be used within a ChartViewProvider');
  }
  return context;
};
